export default __webpack_public_path__ + "static/media/Gwent-Mod2-ParticipantGuide.4459212b.pdf";